<template>
  <v-container class="mt-12" :class="{ 'full-width': fullWidthComponent }">
    <transition name="slide-fade" mode="out-in">
      <component :is="view" :params="params"/>
    </transition>
  </v-container>
</template>

<script>
import Article from "./Article";
import Home from "./Home";
import Menu from "./Menu";
import Slider from "./Slider";
import LightboxGallery from "./LightboxGallery";
import Iframe from "./Iframe";
import Desk from "./Desk";
import YearbookMenu from "./YearbookMenu";
import Yearbook from "./Yearbook";

export default {
  components: {
    Article,
    Home,
    Menu,
    Slider,
    LightboxGallery,
    Iframe,
    Desk,
    YearbookMenu,
    Yearbook,
  },
  data() {
    return {
      view: null,
      params: {},
    };
  },
  async mounted() {
    this.view = "Home";
    this.$store.commit('setScreenNumber', this.$route.query.screenNumber || this.$store.state.screenNumber);
    this.$store.commit('setLanguage', this.$store.state.language = this.$route.query.lang || this.$store.state.language);
    const screenContent = require(`@/../public/static/data/${this.$store.state.screenNumber}/index.json`); // eslint-disable-line
    this.$store.commit('setAccentColor', this.$store.state.accentColor = this.$colors[screenContent.color]);
    this.$vuetify.theme.themes.light.primary = this.$colors[screenContent.color];
    const content = screenContent[this.$route.path];
    this.view = content.view;
    this.params = content.params || content[this.$store.state.language].params;
  },
  computed: {
    fullWidthComponent() {
      return ['Iframe', 'Desk', 'YearbookMenu'].includes(this.view);
    }
  }
};
</script>

<style lang="scss" scoped>
.full-width {
  max-width: 100% !important;
}
</style>
